import SurfaceGeneratorPage from "@/components/SurfaceGeneratorPage";

const PLATFORMS = ["Google Business Profile"];
const MODES = ["What's New", "Offer", "Event", "Product Highlight", "FAQ / Educational"];
const OBJECTIVES = ["Calls", "Direction requests", "Website visits", "Offer redemptions", "Brand trust"];

const CONTEXT_FIELDS = [
  // ── Always visible ──
  { key: "business_name", label: "Business Name", type: "text", placeholder: "e.g., Bright Ideas Consulting", showWhen: { always: true }, section: "Business Info" },
  { key: "business_location", label: "Location / Service Area", type: "text", placeholder: "e.g., Austin, TX — serving Travis County", showWhen: { always: true }, section: "Business Info" },
  { key: "cta_button", label: "CTA Button Type", type: "select", options: ["Call Now", "Get Directions", "Visit Website", "Book Online", "Order Online", "Sign Up", "Learn More", "Get Offer"], showWhen: { always: true }, section: "Business Info" },

  // ── Offer ──
  { key: "offer_title", label: "Offer Title", type: "text", placeholder: "e.g., Spring Strategy Session Special", showWhen: { mode: ["Offer"] }, section: "Offer Details" },
  { key: "offer_details", label: "Discount / Deal", type: "text", placeholder: "e.g., 20% off first session, Free strategy call", showWhen: { mode: ["Offer"] }, section: "Offer Details" },
  { key: "offer_code", label: "Coupon Code", type: "text", placeholder: "e.g., SPRING20 (optional)", showWhen: { mode: ["Offer"] }, section: "Offer Details" },
  { key: "offer_start", label: "Offer Start Date", type: "date", showWhen: { mode: ["Offer"] }, section: "Offer Details" },
  { key: "offer_end", label: "Offer End Date", type: "date", showWhen: { mode: ["Offer"] }, section: "Offer Details" },
  { key: "offer_link", label: "Redemption Link", type: "text", placeholder: "https://yoursite.com/offer", showWhen: { mode: ["Offer"] }, section: "Offer Details" },
  { key: "offer_terms", label: "Terms / Fine Print", type: "text", placeholder: "e.g., New customers only. Cannot combine with other offers.", showWhen: { mode: ["Offer"] }, section: "Offer Details", half: false },

  // ── Event ──
  { key: "event_name", label: "Event Name", type: "text", placeholder: "e.g., Free Home Buyers Workshop", showWhen: { mode: ["Event"] }, section: "Event Details" },
  { key: "event_date", label: "Event Date", type: "date", showWhen: { mode: ["Event"] }, section: "Event Details" },
  { key: "event_time", label: "Event Time", type: "text", placeholder: "e.g., 6:00 PM - 8:00 PM EST", showWhen: { mode: ["Event"] }, section: "Event Details" },
  { key: "event_location", label: "Event Location", type: "text", placeholder: "e.g., 123 Main St, Austin TX or Virtual (Zoom)", showWhen: { mode: ["Event"] }, section: "Event Details" },
  { key: "event_link", label: "Ticket / RSVP Link", type: "text", placeholder: "https://yoursite.com/event", showWhen: { mode: ["Event"] }, section: "Event Details" },

  // ── Product Highlight ──
  { key: "product_name", label: "Product / Service Name", type: "text", placeholder: "e.g., Premium Strategy Package", showWhen: { mode: ["Product Highlight"] }, section: "Product Details" },
  { key: "product_price", label: "Price / Starting At", type: "text", placeholder: "e.g., Starting at $997, Custom pricing", showWhen: { mode: ["Product Highlight"] }, section: "Product Details" },
  { key: "product_features", label: "Key Features / Benefits", type: "textarea", placeholder: "Energy-efficient\nEndless hot water\n12-year warranty", showWhen: { mode: ["Product Highlight"] }, section: "Product Details", half: false },

  // ── FAQ / Educational ──
  { key: "faq_question", label: "Question Being Answered", type: "text", placeholder: "e.g., What's the ROI of content marketing?", showWhen: { mode: ["FAQ / Educational"] }, section: "FAQ Details", half: false },

  // ── What's New ──
  { key: "update_type", label: "Update Type", type: "select", options: ["New Service", "New Hours", "Team Update", "Award / Recognition", "Community Involvement", "Seasonal Reminder", "General Update"], showWhen: { mode: ["What's New"] }, section: "Update Details" },
];

export default function GbpPostBuilderPage() {
  return (
    <SurfaceGeneratorPage
      badge="Local"
      title="GBP Post Builder"
      description="Create Google Business Profile posts with post-type-specific inputs and local context."
      contentType="Google Business Profile Post"
      platformLabel="Platform"
      platforms={PLATFORMS}
      modeLabel="Post type"
      modes={MODES}
      objectiveLabel="Local objective"
      objectives={OBJECTIVES}
      helperText="Add hours, service details, seasonal notes, or preferred CTA wording."
      contextFields={CONTEXT_FIELDS}
    />
  );
}
